import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import * as fromCity from './store/city';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { tap, map, filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CityService {
    private cityUri = `${environment.apiLocation}/CityStateZip`;
    constructor(private http: HttpClient, private log: LoggingService) {}
    get(State?: string, ZipCode?: string): Observable<Array<fromCity.City>> {
        if (!(State || ZipCode)) {
            return of([]);
        }
        this.log.verbose({
            type: 'CityService:get',
            State,
            ZipCode
        });
        return this.http
            .post<Array<fromCity.City>>(this.cityUri, {
                State,
                ZipCode
            })
            .pipe(
                map(x => x && x.map(y => ({ ...y, id: `${y.City}` }))),
                tap(data =>
                    this.log.verbose({
                        type: 'CityService:get:reponse:mapped',
                        data
                    })
                ),
                // filter(x => !!x),
                map(x => (!x ? [] : x)),
                tap(data =>
                    this.log.verbose({
                        type: 'CityService:get:reponse:filtered',
                        data
                    })
                )
            );
    }
}
